import { Step } from 'react-joyride';

export const pipelinePageTourSteps: Step[] = [
  {
    target: 'body',
    content: (
      <div>
        <h2 className="text-xl font-bold mb-2">Welcome to Pipeline View! 🎯</h2>
        <p>This is your visual Kanban board where you can drag leads between stages and manage your sales pipeline effectively.</p>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="view-switcher"]',
    content: 'Switch between Pipeline (Kanban) view and Table view to visualize your leads in different ways.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="total-leads"]',
    content: 'See the total number of leads in your database at a glance.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="search"]',
    content: 'Search for specific leads by name, phone, email, or any other field. Results update instantly as you type.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="owner-filter"]',
    content: 'Filter leads by their assigned owner or view unassigned leads. You can select multiple owners at once.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="apply-filters"]',
    content: 'After setting filters, click Apply to see the filtered results. The number badge shows how many filters are active.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="advanced-filters"]',
    content: 'Access advanced filtering options to narrow down your pipeline by multiple criteria like source, date range, custom fields, and more.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="add-lead"]',
    content: 'Click here to add a new lead manually to your pipeline.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="export"]',
    content: 'Export your pipeline leads to Excel, CSV, or other formats. You can export all leads or just the filtered ones.',
    placement: 'left',
  },
  {
    target: '[data-tour="status-column"]',
    content: 'Each column represents a stage in your sales pipeline. The number shows how many leads are in this stage. Drag and drop leads between columns to update their status.',
    placement: 'right',
  },
  {
    target: '[data-tour="column-select-all"]',
    content: 'Select all leads in a column at once for bulk actions. Great for moving multiple leads or changing ownership.',
    placement: 'right',
  },
  {
    target: '[data-tour="lead-card"]',
    content: 'Lead cards show key information: phone number, name, source, date, and owner. Click to view full details. Drag to move between stages.',
    placement: 'right',
  },
  {
    target: '[data-tour="card-checkbox"]',
    content: 'Select individual leads by checking their boxes (appears on hover). Select multiple leads for bulk actions.',
    placement: 'right',
  },
  {
    target: '[data-tour="drag-drop-hint"]',
    content: 'Drag any lead card and drop it into another column to change its status. The system automatically updates the lead\'s stage and tracks the history.',
    placement: 'right',
  },
  {
    target: '[data-tour="bulk-actions"]',
    content: 'When you select leads, bulk actions appear here. You can change owner, export selected, add reminders, or delete multiple leads at once.',
    placement: 'bottom',
  },
  {
    target: 'body',
    content: (
      <div>
        <h2 className="text-xl font-bold mb-2">Tour Complete! 🎉</h2>
        <p className="mb-3">You're ready to manage your pipeline! Drag leads between stages, use filters, and take bulk actions to streamline your sales process.</p>
        <p className="text-sm text-gray-600">You can restart this tour anytime by clicking the info icon.</p>
      </div>
    ),
    placement: 'center',
  },
];
